import { XeroLogo } from '@approvalmax/ui';
import { Box, Grid, Label, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { accountParams } from './XeroAccountDetails.constants';
import { messages } from './XeroAccountDetails.messages';
import type { XeroAccountDetailsProps } from './XeroAccountDetails.types';

export const XeroAccountDetails = memo<XeroAccountDetailsProps>((props) => {
    const { name, bankAccountConnected, ...restProps } = props;

    return (
        <Box color={bankAccountConnected ? 'white100' : 'silver80'} radius='xsmall'>
            <Grid gap={8} gridTemplateColumns='max-content auto'>
                <XeroLogo width={28} height={28} />

                <Grid gap={4}>
                    <Text font='label' fontSize='small' color={bankAccountConnected ? 'midnight80' : 'midnight60'}>
                        {name}
                    </Text>

                    <Grid gap={8} gridTemplateColumns='48px 64px auto'>
                        {accountParams.map((prop) => (
                            <div key={prop}>
                                <Label size='xsmall'>{messages[prop]}</Label>

                                <Text
                                    font='label'
                                    fontSize='small'
                                    color={bankAccountConnected ? undefined : 'midnight60'}
                                >
                                    {restProps[prop]}
                                </Text>
                            </div>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
});

XeroAccountDetails.displayName = 'XeroAccountDetails';
